import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=6dc41fc5&scoped=true"
import script from "./Welcome.vue?vue&type=script&lang=ts"
export * from "./Welcome.vue?vue&type=script&lang=ts"
import style0 from "./Welcome.vue?vue&type=style&index=0&id=6dc41fc5&prod&lang=css"
import style1 from "./Welcome.vue?vue&type=style&index=1&id=6dc41fc5&prod&scoped=true&lang=css"
import style2 from "./Welcome.vue?vue&type=style&index=2&id=6dc41fc5&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc41fc5",
  null
  
)

export default component.exports